import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-estate-list-page',
    templateUrl: './estate-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EstateListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Estates');
  }

  handleRowSelect(data) {
    this.router.navigate(['/entity-data/estate', data['SystemEstateRef']]);
  }

  getRowHref = (row) => {
    const estateRef = row['SystemEstateRef'];
    return `/entity-data/estate/${estateRef}`;
  }
}
